import { CreateNewStack } from "../../state/stackAtoms";
import { IsInPortrait, TogglePanelFor } from "../../state/selectors";
import { TopBarControl } from "../StyledControl";
import { text } from "@quickpoint.me/shared";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { MousedOverTextHelper } from "../../state/uiAtoms";

function StacksControl() {
	const setTextHelper = useSetRecoilState(MousedOverTextHelper);
	const isInPortrait = useRecoilValue(IsInPortrait);
	const togglePanelFor = useSetRecoilState(TogglePanelFor);
	const setCreateNewStack = useSetRecoilState(CreateNewStack);

	const handleClick = () => {
		togglePanelFor("stacks");
		// browsing intent: the create row only opens from the New buttons
		setCreateNewStack(false);
	};

	const mouseOver = () => {
		setTextHelper(text.controls.stacks);
	};

	const mouseLeave = () => {
		setTextHelper(undefined);
	};

	return (
		<TopBarControl
			$isInPortrait={isInPortrait}
			id="control-stories"
			onClick={handleClick}
			data-testid="stacks-control"
			onMouseOver={mouseOver}
			onMouseLeave={mouseLeave}
			aria-label={text.controls.stacks}
		>
			{text.controls.stacks}
		</TopBarControl>
	);
}

export default StacksControl;
